
export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR"
export const TOGGLE_SIDEBAR_FAILURE = "TOGGLE_SIDEBAR_FAILURE"